/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { SnackContainer } from './style';
import { Snackbar } from './snackbar';
import { useBreakpoint } from '../../hooks';

const withSnackbar = (snackHoCOptions = {}) => Component => props => {
  const [maxWidthVisibility] = useBreakpoint(snackHoCOptions.maxWidth);
  return (
    <SnackContainer>
      <Component {...props} />
      {!maxWidthVisibility && <Snackbar {...snackHoCOptions} />}
    </SnackContainer>
  );
};

export { withSnackbar };
